var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M246,128c0,2.2,0,6.8-2.3,9.1c-13.6,20.4-29.5,36.3-49.9,49.9c-20.4,11.3-43.1,18.1-65.8,18.1c-22.7,0-45.4-6.8-65.8-18.1c-20.4-11.4-38.6-29.5-49.9-49.9c-2.3-2.3-2.3-6.8-2.3-9.1c0-2.3,0-6.8,2.3-9.1C23.6,98.5,41.8,82.6,62.2,69c20.4-11.4,43.1-18.2,65.8-18.2c22.7,0,45.4,6.8,65.8,18.2c20.4,11.3,38.6,29.5,49.9,49.9C243.7,123.4,246,125.7,246,128z M227.8,128c-13.6-20.4-29.5-36.3-49.9-47.7c4.5,9.1,9.1,20.4,9.1,29.5c0,15.9-6.8,29.5-18.1,43.1c-11.4,11.3-25,18.1-43.1,18.1c-15.9,0-29.5-6.8-43.1-18.1c-11.4-11.4-18.2-25-18.2-43.1c0-11.4,2.3-20.4,9.1-29.5C53.1,91.7,37.3,107.6,23.6,128C35,146.1,50.8,159.8,69,171.1c18.2,11.4,36.3,15.9,59,15.9c20.4,0,40.8-4.6,59-15.9C200.6,162.1,216.5,146.1,227.8,128z M130.3,82.6c2.3-2.3,2.3-2.3,2.3-4.5c0-2.3,0-2.3-2.3-4.6c-2.3-2.2-2.3-2.2-4.6-2.2c-11.3,0-20.4,4.5-29.5,11.3c-9,6.8-11.3,18.2-11.3,29.6c0,2.2,0,2.2,2.3,4.5c2.3,2.3,2.3,2.3,4.5,2.3c2.3,0,2.3,0,4.6-2.3c2.3-2.3,2.3-2.3,2.3-4.5c0-6.8,2.3-13.7,9.1-20.4c4.5-4.5,11.3-9.1,20.4-9.1C128,84.9,128,82.6,130.3,82.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/viewIcon.9c33f6bf5c47070cf248c903fbb02ca0.svg";
export { ForwardRef as ReactComponent };